module.exports = __webpack_public_path__ + "img/buy_super_th.dc3e633d.png";